// Iter 387 — Regularización de anticipos: utilidades compartidas.
export { fmtCLP } from '../egresos/egresosUtils';

export const LADO_INFO = {
  egresos: {
    titulo: 'Egresos pendientes de aplicar', sub: 'Anticipos entregados a proveedores (Cuentas por Pagar)',
    auxiliar: 'Proveedor', auxiliarPlural: 'proveedores', documento: 'Factura de proveedor', anticipo: 'Comprobante de Egreso', accionDoc: 'pago',
  },
  ingresos: {
    titulo: 'Ingresos pendientes de aplicar', sub: 'Anticipos recibidos de clientes (Cuentas por Cobrar)',
    auxiliar: 'Cliente', auxiliarPlural: 'clientes', documento: 'Factura de venta', anticipo: 'Recibo de Caja', accionDoc: 'cobro',
  },
};

export function fmtRut(rutNorm) {
  const r = String(rutNorm || '').replace(/[^0-9kK]/g, '').toUpperCase();
  if (r.length < 2) return rutNorm || '';
  const cuerpo = r.slice(0, -1).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${cuerpo}-${r.slice(-1)}`;
}
